// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Wizh","selects":"Documents_selects__LhsaT"};